export const LinkGen = {
  RFQ: Object.assign(() => "/", {
    New: () => "/rfq/new",
    Extract: () => "/rfq/extract",
    Detail: (ID: number | string) => `/rfq/${ID}`,
  }),
  Client: Object.assign(() => "/borrower", {
    Detail: (ID: number | string) => `/borrower/${ID}`,
  }),
  Purchase: Object.assign(() => "/purchases", {
    New: () => "/purchases/new",
    Detail: (ID: number | string) => `/purchases/${ID}`,
  }),
  Integration: Object.assign(() => "/integration", {}),
  Settings: () => "/settings",
  Subscription: Object.assign(() => "/subscription", {
    Success: () => "/subscription/success",
  }),
  Auth: () => "/auth",
  AuthConsume: (id: string | number, secret: string) => `/auth/${id}/${secret}`,
  SignUp: () => "/sign-up",
  Submit: (token: string) => `/submit/${token}`,
};

export const QueryKeys = {
  Profile: () => ["PROFILE"],
  CompanyFees: () => ["COMPANY_FEES"],
  Address: Object.assign((id: number | null | undefined) => ["ADDRESS", id], {
    Search: (query: string) => ["ADDRESS", "SEARCH", query],
    Places: (query: string, sessionToken: string) => [
      "ADDRESS",
      "PLACES",
      query,
      sessionToken,
    ],
  }),
  Mortgage: Object.assign((id: number) => ["MORTGAGE", id], {
    List: () => ["MORTGAGE"],
    Offer: (mortgageID: number, offerID: number | null | undefined) => [
      "MORTGAGE",
      mortgageID,
      "OFFER",
      offerID,
    ],
  }),
  Purchase: Object.assign((id: number) => ["PURCHASE", id], {
    List: () => ["PURCHASE"],
    Offer: (purchaseID: number, offerID: number | null | undefined) => [
      "PURCHASE",
      purchaseID,
      "OFFER",
      offerID,
    ],
  }),
  Upload: Object.assign((id: number) => ["UPLOAD", id], {}),
  Borrower: Object.assign((id: number | null | undefined) => ["BORROWER", id], {
    List: () => ["BORROWER"],
    Search: (query: string) => ["BORROWER", "SEARCH", query],
  }),
  StripePricing: () => ["STRIPE_PRICING"],
};
